export const formatCount = (value) => {
  const normalized = Number(value) || 0;
  return normalized.toLocaleString('ru-RU');
};

export const formatHoursValue = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return '0 ч';
  }

  return `${Number(value).toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  })} ч`;
};

export const formatMoney = (value, currency = 'RUB') => {
  const normalized = Number(value) || 0;

  return new Intl.NumberFormat(currency === 'RUB' ? 'ru-RU' : 'en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: currency === 'RUB' ? 0 : 2,
    maximumFractionDigits: currency === 'RUB' ? 0 : 2
  }).format(normalized);
};

export const formatPercent = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return '—';
  }

  return `${Number(value).toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  })}%`;
};

export const formatMinutes = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return '—';
  }

  return `${Number(value).toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  })} мин`;
};

export const formatNullableMoney = (value, currency = 'RUB') => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  return formatMoney(value, currency);
};

export const formatNullableNumber = (value) => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  return Number(value).toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
};

export const formatGenerationStatus = (status) => {
  const map = {
    succeed: 'Успешно',
    success: 'Успешно',
    failed: 'Ошибка',
    error: 'Ошибка',
    pending: 'В очереди',
    processing: 'В работе',
    canceled: 'Отменено'
  };

  return map[status] || status || '—';
};

export const formatPaymentStatus = (status) => {
  const map = {
    succeeded: 'Успешно',
    waiting_for_capture: 'Ждёт подтверждения',
    canceled: 'Отменён',
    pending: 'В обработке'
  };

  return map[status] || status || '—';
};
